(function () {
  const initialised = new WeakSet();

  const aliases = {
    'Manchester City': 'man city',
    'Manchester United': 'man united man utd manutd',
    'Newcastle United': 'newcastle toon',
    'Nottingham Forest': 'forest notts forest',
    'Queens Park Rangers': 'qpr',
    'Sheffield United': 'sheff utd',
    'Sheffield Wednesday': 'sheff wed',
    'Tottenham Hotspur': 'tottenham spurs',
    'West Bromwich Albion': 'west brom wba',
    'West Ham United': 'west ham',
    'Wolverhampton Wanderers': 'wolves',
  };

  function normalise(value) {
    return value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function track(eventName, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, detail || {}));
  }

  function initialise(root) {
    if (initialised.has(root)) return;
    initialised.add(root);

    const input = root.querySelector('[data-football-pack-input]');
    const form = root.querySelector('[data-football-pack-form]');
    const results = root.querySelector('[data-football-pack-results]');
    const tabs = Array.from(root.querySelectorAll('[data-football-pack-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-football-pack-panel]'));
    const clubLinks = Array.from(root.querySelectorAll('[data-football-pack-club]'));

    if (!input || !form || !results || !clubLinks.length) return;

    const records = clubLinks.map((link) => ({
      name: link.dataset.clubName,
      league: link.dataset.clubLeague,
      href: link.getAttribute('href'),
      searchable: normalise(`${link.dataset.clubName} ${aliases[link.dataset.clubName] || ''}`),
    }));

    let visibleRecords = [];
    let activeIndex = -1;

    function closeResults() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      visibleRecords = [];
      activeIndex = -1;
    }

    function updateActiveResult() {
      const options = Array.from(results.querySelectorAll('[role="option"]'));
      options.forEach((option, index) => {
        const selected = index === activeIndex;
        option.setAttribute('aria-selected', String(selected));
        if (selected) input.setAttribute('aria-activedescendant', option.id);
      });
    }

    function score(record, query) {
      const name = normalise(record.name);
      const queryWords = query.split(' ').filter(Boolean);
      if (name === query) return 0;
      if (name.startsWith(query)) return 1;
      if (record.searchable.startsWith(query)) return 2;
      if (name.includes(query)) return 3;
      if (queryWords.every((word) => record.searchable.includes(word))) return 4;
      return 99;
    }

    function renderResults() {
      const query = normalise(input.value);
      if (!query) {
        closeResults();
        return;
      }

      visibleRecords = records
        .map((record) => ({ record, score: score(record, query) }))
        .filter((item) => item.score < 99)
        .sort((a, b) => a.score - b.score || a.record.name.localeCompare(b.record.name))
        .slice(0, 7)
        .map((item) => item.record);

      results.innerHTML = '';
      activeIndex = -1;

      if (!visibleRecords.length) {
        const empty = document.createElement('div');
        empty.className = 'football-pack__no-results';
        empty.textContent = 'No club found. Try the full club name or browse by league below.';
        results.appendChild(empty);
      } else {
        visibleRecords.forEach((record, index) => {
          const option = document.createElement('a');
          option.className = 'football-pack__result';
          option.href = record.href;
          option.id = `${root.id}-result-${index}`;
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', 'false');

          const text = document.createElement('span');
          const name = document.createElement('strong');
          const league = document.createElement('span');
          const arrow = document.createElement('b');
          name.textContent = record.name;
          league.textContent = record.league;
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '→';
          text.append(name, league);
          option.append(text, arrow);

          option.addEventListener('click', () => {
            track('football_pack_result_click', {
              club: record.name,
              league: record.league,
              query_length: input.value.trim().length,
            });
          });
          results.appendChild(option);
        });
      }

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    input.addEventListener('input', renderResults);
    input.addEventListener('focus', () => {
      if (input.value.trim()) renderResults();
    });

    input.addEventListener('keydown', (event) => {
      if (results.hidden || !visibleRecords.length) return;
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        activeIndex = (activeIndex + 1) % visibleRecords.length;
        updateActiveResult();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        activeIndex = activeIndex <= 0 ? visibleRecords.length - 1 : activeIndex - 1;
        updateActiveResult();
      } else if (event.key === 'Enter' && activeIndex >= 0) {
        event.preventDefault();
        const record = visibleRecords[activeIndex];
        track('football_pack_result_click', {
          club: record.name,
          league: record.league,
          query_length: input.value.trim().length,
        });
        window.location.assign(record.href);
      } else if (event.key === 'Escape') {
        closeResults();
      }
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!visibleRecords.length) {
        input.focus();
        renderResults();
        return;
      }
      const record = visibleRecords[0];
      track('football_pack_result_click', {
        club: record.name,
        league: record.league,
        query_length: input.value.trim().length,
      });
      window.location.assign(record.href);
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const league = tab.dataset.footballPackTab;
        tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.footballPackPanel !== league;
        });
        track('football_pack_league_select', { league });
      });
    });

    root.querySelectorAll('[data-football-pack-quick-pick]').forEach((link) => {
      link.addEventListener('click', () => {
        track('football_pack_quick_pick', { club: link.textContent.trim() });
      });
    });

    clubLinks.forEach((link) => {
      link.addEventListener('click', () => {
        track('football_pack_club_click', {
          club: link.dataset.clubName,
          league: link.dataset.clubLeague,
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeResults();
    });
  }

  function initialiseAll(scope) {
    scope.querySelectorAll('[data-football-pack]').forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(document));
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
